module.exports = __webpack_public_path__ + "img/icon_2_40.5d693011.png";